import { Refresh } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const RefreshIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Refresh width={size} height={size} color={color} {...rest} />;

RefreshIcon.displayName = 'RefreshIcon';

export default RefreshIcon;
